module.exports = __webpack_public_path__ + "images/c834c6eaf43e5b5c8e7f6ad818f20ef3-ab-map.png";